import { IsNotEmpty, IsUUID, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import { TimezoneDto } from './timezone.dto';

export class UpdateCompanyTimezoneDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @ValidateNested()
  @Type(() => TimezoneDto)
  newTimezone: TimezoneDto;
}
